export default "__VITE_ASSET__Cua87ziY__"